// @flow
// eslint-disable-next-line max-classes-per-file
import React, { Component } from 'react';
import superagent from 'superagent';
import ApiClient from '../../api/ApiClient';
import SmsLinkInput from './SMSLinkInput';
import phoneValidation from '../../helpers/validations/phoneValidation';
import { track } from '../../helpers/Tracking/Analytics';

import '../../../static/scss/components/SMSLinkInput.scss';

class Api {
  constructor(req, agent) {
    this.client = new ApiClient(req, agent);
  }

  postSms(phoneNumber) {
    return this.client.post('/v5/crm/app-link', {
      data: {
        phone_number: phoneNumber
      }
    });
  }
}

const client = new Api(null, superagent);

const shouldValidateForm = (baseClassName, isValid, postError) =>
  isValid && !postError ? '' : `${baseClassName}--failed-validation`;

const shouldHideElement = (baseClassName, hasSubmitted, postSuccess) =>
  hasSubmitted === true && postSuccess ? `${baseClassName}__hidden` : '';

const inputErrorMessage = 'Please enter a valid UK number';
const postSuccessMessage = (
  <p>Fantastic, you will receive an SMS with a download link</p>
);

export type ConditionallyRenderErrorMessageProps = {
  error: boolean,
  errorMessage: string
};

const ConditionallyRenderErrorMessage = (
  props: ConditionallyRenderErrorMessageProps
) => {
  const { error, errorMessage } = props;

  return error ? (
    <p className="c-sms-container__error-container__p--error">{errorMessage}</p>
  ) : null;
};

export type ConditionallyRenderSmsMessagesProps = {
  isValid: boolean,
  postError: boolean,
  postSuccess: boolean,
  baseClassName: string,
  postErrorMessage: string
};

const ConditionallyRenderSmsMessages = (
  props: ConditionallyRenderSmsMessagesProps
) => {
  const {
    isValid,
    postError,
    postSuccess,
    baseClassName,
    postErrorMessage
  } = props;

  let messages = '';
  if (postSuccess) {
    messages = postSuccessMessage;
  } else {
    messages = (
      <div className="c-sms-container__error-container">
        <ConditionallyRenderErrorMessage
          name="postError"
          baseClassName={baseClassName}
          error={postError}
          errorMessage={postErrorMessage}
        />
        <ConditionallyRenderErrorMessage
          name="inputError"
          baseClassName={baseClassName}
          error={!isValid}
          errorMessage={inputErrorMessage}
        />
      </div>
    );
  }
  return <div>{messages}</div>;
};

type SmsLinkFormProps = {};

export default class SmsLinkForm extends Component<SmsLinkFormProps> {
  constructor(props: SmsLinkFormProps) {
    super(props);
    this.state = {
      inputValue: '',
      isValid: true,
      hasSubmitted: false,
      postError: false,
      postErrorMessage: '',
      postSuccess: false
    };
  }

  inputChange(e) {
    this.setState({ inputValue: e.target.value });
  }

  onSubmit(e) {
    e.preventDefault();
    this.setState({ hasSubmitted: true }, () => {
      const { inputValue } = this.state;

      if (phoneValidation(inputValue)) {
        track('click:download-app:send-link');
        this.postSMS();
        return;
      }

      this.setState({ isValid: false });
    });
  }

  postSMS() {
    const phoneNumber = this.state.inputValue;
    client
      .postSms(phoneNumber)
      .then(() => {
        this.setState({ postSuccess: true, isValid: true });
      })
      .catch(error => {
        const postErrorMessage = error.statusText || 'Could not send SMS';
        this.setState({ postError: true, postErrorMessage });
      });
  }

  render() {
    const baseClassName = 'c-sms-container';
    const {
      isValid,
      hasSubmitted,
      postError,
      postErrorMessage,
      postSuccess
    } = this.state;
    const isValidClass = shouldValidateForm(baseClassName, isValid, postError);
    const isHiddenClass = shouldHideElement(
      baseClassName,
      hasSubmitted,
      postSuccess
    );

    return (
      <>
        <p className={isHiddenClass}>
          Enter your mobile number below to receive a one-time text message with
          a link to download the free JustPark app.
        </p>
        <form
          className={`${baseClassName} ${isValidClass} ${isHiddenClass} `}
          onSubmit={this.onSubmit.bind(this)}
        >
          <SmsLinkInput
            value={this.state.inputValue}
            onChange={this.inputChange.bind(this)}
            placeholder="Enter your mobile number"
          />
          <button type="submit" className="c-sms-container__button">
            Send Link
          </button>
        </form>
        <ConditionallyRenderSmsMessages
          isValid={isValid}
          postError={postError}
          postSuccess={postSuccess}
          baseClassName={baseClassName}
          postErrorMessage={postErrorMessage}
        />
      </>
    );
  }
}

SmsLinkForm.defaultProps = {
  name: 'London'
};
